<template>
  <v-select
    :value="value"
    item-value="id"
    item-text="name"
    :items="statusesList"
    :readonly="readonly"
    :rules="calculateRules"
    flat
    solo
    dense
    small-chips
    hide-details
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:selection="{ item, select, selected, disabled }">
      <v-chip
        text-color="white"
        :color="item.color"
        :input-value="selected"
        :disabled="disabled"
        small
        @click="select"
      >
        {{ item.name }}
      </v-chip>
    </template>
  </v-select>
</template>

<script>
import { mapState } from 'vuex';
import { mapCacheActions } from 'vuex-cache';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import { notEmpty } from '@/modules/_global/variables/rules';
import statuses, {
  NEW,
  OCCUPIED,
  CANCELLED,
  COMPLETED
} from '../../common/statuses';

export default {
  name: 'BookingReservationsStatus',

  mixins: [i18nRefreshData],

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: {
      type: Number,
      default: NEW,
      validator: prop => Object.values(statuses).includes(prop)
    },
    readonly: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => []
    },
    lockId: {
      type: Number,
      default: null
    }
  },

  computed: {
    ...mapState('booking_reservations', ['bookingReservationsStatuses']),

    calculateRules() {
      if (this.readonly) {
        return [];
      }

      return this.rules.length ? this.rules : [notEmpty];
    },

    statusesList() {
      return this.bookingReservationsStatuses.map(status => {
        return {
          id: status.id,
          name: status.name,
          color: status.color,
          disabled: !this.enabledStatuses.includes(status.id)
        };
      });
    },

    enabledStatuses() {
      switch (this.value) {
        case NEW:
          return this.getNewEnabledStatuses();
        case OCCUPIED:
          return [OCCUPIED, CANCELLED];
        case CANCELLED:
          return [CANCELLED];
        case COMPLETED:
          return [COMPLETED];
        default:
          return [];
      }
    }
  },

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapCacheActions('booking_reservations', [
      'getBookingReservationsStatuses'
    ]),

    refreshData() {
      this.getBookingReservationsStatuses();
    },

    getNewEnabledStatuses() {
      if (this.lockId === null) {
        return [NEW, OCCUPIED, CANCELLED];
      }

      return [NEW, CANCELLED];
    }
  }
};
</script>
